import { animations } from "helpers/animations";
import { useForm } from "hooks/useForm";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { blue, green } from "@mui/material/colors";
import { useToggle } from "hooks/useToggle";
import { Grid, TextField, FormControl } from "@material-ui/core";
import {
  fieldValidationsPass,
  initialValuesPass,
} from "./inputValues";
import RegularButton from "components/CustomButtons/Button";
import { resetUserPassword } from "redux/actions/users/usersActions";

const style = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const ChangePassForm = ({ id, onClose }) => {
  const dispatch = useDispatch()
  const {
    inputValues,
    handleInputOnChange,
    fieldErrors,
    runValidates,
  } = useForm(initialValuesPass, fieldValidationsPass);
  const { password, confirmPass } = inputValues;
  const [isPassword, setIsPassword] = useState(true);
  const [showPass, setShowPass] = useToggle();

  useEffect(() => {
    if (password.length > 3 && confirmPass.length > 3) {
      password === confirmPass ? setIsPassword(false) : setIsPassword(true);
    }
  }, [password, confirmPass]);

  const handleSubmit = () => {
    if (runValidates()) return;
    dispatch(resetUserPassword(id, password, onClose))
  };
  return (
    <FormControl>
      <Grid container spacing={1}>
        <Grid item xs={12}style={style}>
          <TextField
            label="Contraseña"
            name="password"
            type={showPass ? "text" : "password"}
            value={password}
            variant="outlined"
            fullWidth
            required={true}
            error={fieldErrors.password}
            helperText={fieldErrors.password || ""}
            onChange={handleInputOnChange}
          />
        </Grid>

        <Grid item xs={12}style={style}>
          <TextField
            label="Confirmar contraseña"
            name="confirmPass"
            type={showPass ? "text" : "password"}
            value={confirmPass}
            variant="outlined"
            fullWidth
            required={true}
            error={fieldErrors.confirmPass}
            helperText={fieldErrors.confirmPass || ""}
            onChange={handleInputOnChange}
            InputProps={{
              endAdornment: (
                <>
                  <RegularButton
                    justIcon
                    round
                    tooltip={
                      showPass ? "Ocultar contraseña" : "Mostrar contraseña"
                    }
                    color="transparent"
                    onClick={setShowPass}
                    style={{marginRight: 10}}
                  >
                    {showPass ? (
                      <VisibilityIcon
                        className={animations.fadeIn}
                        style={{ color: green[300] }}
                      />
                    ) : (
                      <VisibilityOffIcon
                        className={animations.fadeIn}
                        style={{ color: green[500] }}
                        onClick={setShowPass}
                      />
                    )}
                  </RegularButton>
                  {isPassword ? (
                    <LockOpenIcon
                      className={animations.fadeIn}
                      style={{ color: blue[500], }}
                    />
                  ) : (
                    <LockIcon
                      className={animations.fadeIn}
                      style={{ color: blue[700], }}
                    />
                  )}
                </>
              ),
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{ ...style, justifyContent: "flex-end" }}
        ></Grid>
        <Grid
          item
          xs={12}
          style={{ ...style, justifyContent: "flex-end", gap: 15 }}
        >
          <RegularButton color="white" onClick={onClose}>
            Cancelar
          </RegularButton>
          <RegularButton color="info" onClick={handleSubmit}>
            Aceptar
          </RegularButton>
        </Grid>
      </Grid>
    </FormControl>
  );
};
